import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'app-physician-information',
  templateUrl: './physician-information.component.html',
  styleUrls: ['./physician-information.component.scss']
})
export class PhysicianInformationComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  notesIcon =
    this.RESOURCE_SERVER_URL +
    '/assets/images/process-claims/icons/menu_book.svg';
    addIcon = this.RESOURCE_SERVER_URL + '/assets/images/addPurple.svg';
  editIcon = this.RESOURCE_SERVER_URL + '/assets/images/Edit.svg';

  addCircleIcon = this.RESOURCE_SERVER_URL + '/assets/images/add.svg';
  selectedCircleIndex: number = 0;
  claimId: any;
  isLoading: boolean = false;
  getPhysicianDetails: any;
  selectedPhysicianUUID: any;
  physicianDetail: any = {};
  physicianDetailList: any = [];
  natureOfIllnessIndex: number;
  isProcedure: boolean = false;
  isProcedureDetails: any;
  dialCodesArr: any = [];

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<PhysicianInformationComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  async ngOnInit() {
    this.claimId = this.data.claimID;
    await this.initialDropdown();
    await this.getAllPhysicians();
    await this.getPhysicianById(0);
  }

  async initialDropdown() {
    this.isLoading = true;   
    try {
      let url =
        environment.API_CONFIG_COMMON +
        'lookup?list=Occupation,Country,occupationCodes,countryCodes,DialCode';
      let dropDownResponse = await this.commonService.commonGet(url);
      this.dialCodesArr = dropDownResponse.body.DialCode;
      this.isLoading = false;
    } catch (err) {
      console.log('Get API Error - Claim Data', err);
      this.isLoading = false;
    }
  }

  async onDataInput(event, key) {
    this.physicianDetail[key] = event;
  }
  async onNatureOfIllnessInput(event, key, uuid) {
    for (let item of this.physicianDetail.natureOfIllness) {
      if (uuid == item.uuid) {
        item[key] = event;
      }
    }
  }
  async getAllPhysicians() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/physician';
      let getPhysiciansResponse = await this.commonService.commonGet(url);
      this.getPhysicianDetails = getPhysiciansResponse.body.content;
      if (this.getPhysicianDetails.length == 0) {
        await this.createPhysician();
      }
      this.isLoading = false;
    } catch (error) {
      console.log('Get Claim By Id Failed', error);
      this.isLoading = false;
    }
  }

  async createPhysician() {
     //////////////to show the previous data before doing patch//////////
     this.physicianDetailList[this.selectedCircleIndex] = cloneDeep(
      this.physicianDetail
    );
    this.isLoading = true;
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/physician';
      await this.commonService.commonPost(url, {});
      await this.getAllPhysicians();
      this.selectedCircleIndex = this.getPhysicianDetails.length - 1;
      await this.getPhysicianById(this.selectedCircleIndex);
      this.isLoading = false;
    } catch (error) {
      console.log('Get Claim By Id Failed', error);
      this.isLoading = false;
    }
  }

  async getPhysicianById(selectedCircleIndex) {
    this.isLoading = true;
    let physicianUuid = this.getPhysicianDetails[selectedCircleIndex].uuid;
    this.selectedPhysicianUUID = physicianUuid;
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/physician/' +
        physicianUuid;
      let response = await this.commonService.commonGet(url);
      ////////////////////////////////////////////////////////////////////////
      let physicianDetail = {
        natureOfIllness: response.body.natureOfIllness.map((nature) => ({
          natureOfIllness: nature.natureOfIllness,
          dateOfConsultation: nature.dateOfConsultation,
          prescription: nature.prescription,
          uuid: nature.uuid,
        })),
        hospitalAffiliations: response.body.hospitalAffiliations,
        countryCode: response.body.countryCode,
        contactNumber: response.body.contactNumber,
        physicianAddress: response.body.physicianAddress,
        physicianName: response.body.physicianName,
        uuid: response.body.uuid,
      };
      ////////////////////////////////////////////////////////////////
      this.physicianDetail = cloneDeep(physicianDetail);
      this.physicianDetailList[selectedCircleIndex] = cloneDeep(
        this.physicianDetail
      );
      this.isLoading = false;
    } catch (err) {
      console.log('Get API Error - Claim Data', err);
      this.isLoading = false;
    }
  }

  async selectCircle(index: number) {
    this.physicianDetailList[this.selectedCircleIndex] = cloneDeep(
      this.physicianDetail
    );
    this.selectedCircleIndex = index;
    if (this.physicianDetailList[this.selectedCircleIndex]) {
      this.physicianDetail = cloneDeep(
        this.physicianDetailList[this.selectedCircleIndex]
      );
      this.selectedPhysicianUUID = this.physicianDetail.uuid;
    } else {
      this.getPhysicianById(index);
      this.physicianDetail = cloneDeep(
        this.physicianDetailList[this.selectedCircleIndex]
      );
    }
  }

  // Patch API - Update Claim Data by persons.
  async updateHospitalsById(physicianUuid, body) {
    this.isLoading = true;
    delete body.uuid;
    delete body.createdDate;
    for (let item of body.natureOfIllness) {
      delete item.uuid;
    }
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/physician/' +
        physicianUuid;
      await this.commonService.commonPatch(url, body);
      this.isLoading = false;
    } catch (err) {
      console.log('Patch API Error - Update Person type', err);
      this.isLoading = false;
    }
  }

  async createNatureOfIllness(index) {
    this.isLoading = true;
    let physicianUuid = this.selectedPhysicianUUID;
    let body = cloneDeep(this.physicianDetail);
    await this.updateHospitalsById(physicianUuid, body);
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/physician/' +
        physicianUuid +
        '/illness';
      await this.commonService.commonPost(url, {});
      await this.getPhysicianById(index);
      this.isLoading = false;
    } catch (error) {
      console.log('Get Claim By Id Failed', error);
      this.isLoading = false;
    }
  }

  async saveAndValidate() {
    this.physicianDetailList[this.selectedCircleIndex] = cloneDeep(
      this.physicianDetail
    );
    for (let item of this.physicianDetailList) {
      await this.updateHospitalsById(item.uuid, cloneDeep(item));
    }
    this.dialogRef.close();
  }

  async onCloseDialog() {
    this.dialogRef.close();
  }
  async onOpenProcedureDialog(data, index) {
    this.isProcedure = true;
    this.natureOfIllnessIndex = index;
    console.log('index', this.natureOfIllnessIndex);
    this.isProcedureDetails = data;
    console.log('procedure::', this.isProcedureDetails);
  }

  onCloseProcedure() {
    this.isProcedure = false;
  }
  onChangesPrescriptionInput(event, index) {
    this.physicianDetail.natureOfIllness[index].prescription = event;
  }

}
